import { render, staticRenderFns } from "./denomTable.vue?vue&type=template&id=8da1da08&scoped=true"
import script from "./denomTable.vue?vue&type=script&lang=js"
export * from "./denomTable.vue?vue&type=script&lang=js"
import style0 from "./denomTable.vue?vue&type=style&index=0&id=8da1da08&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8da1da08",
  null
  
)

export default component.exports